import React from 'react';
import { bool, object, string } from 'prop-types';
import { buildStay22EmbedUrl } from '../../util/stay22Embed';
import css from './SeoDiscovery.module.css';

/**
 * Stay22 map and OpenTable restaurant integration slots.
 */
const cleanParam = value => String(value || '').trim();

const venueAddress = venue =>
  [venue?.address, venue?.city, venue?.state, venue?.country].filter(Boolean).join(', ');

const stay22Url = ({ content, venue, subpageSlug }) => {
  const aid = cleanParam(content.stay22Aid);
  if (!aid || !venue) {
    return null;
  }

  return buildStay22EmbedUrl({
    aid,
    lat: venue.latitude,
    lng: venue.longitude,
    address: venueAddress(venue) || venue.venueName,
    venueName: venue.venueName,
    mainColor: cleanParam(content.stay22MainColor) || 'ff822f',
    campaign: [
      cleanParam(content.stay22Campaign) || 'seo-discovery',
      subpageSlug || 'venue-page',
    ],
  });
};

const SeoPartnerSlots = props => {
  const { partnerBlock, showHeading = true, subpageSlug, venue } = props;
  const content = partnerBlock?.content || {};
  const showStay22 = content.stay22Enabled && (!subpageSlug || subpageSlug === 'places-to-stay');
  const showOpenTable = content.openTableEnabled && subpageSlug === 'restaurants';
  const mapUrl = showStay22 ? stay22Url({ content, venue, subpageSlug }) : null;

  if (!showStay22 && !showOpenTable) {
    return null;
  }

  return (
    <div className={css.partnerSlot}>
      {showStay22 ? (
        <section>
          {showHeading ? <h2>Places to stay near {venue?.venueName}</h2> : null}
          {mapUrl ? (
            <iframe
              title={`Places to stay near ${venue?.venueName}`}
              className={css.stay22Map}
              src={mapUrl}
              width="100%"
              height="460"
              frameBorder="0"
              loading="lazy"
            />
          ) : (
            <p>
              <strong>Places to stay:</strong> Add <code>SEO_DISCOVERY_STAY22_AID</code> to show
              the Stay22 map for this venue.
            </p>
          )}
        </section>
      ) : null}
      {showOpenTable ? (
        <p>
          <strong>Restaurants:</strong> OpenTable reservation widgets can be embedded here when{' '}
          <code>SEO_DISCOVERY_OPENTABLE_ENABLED=true</code>.
        </p>
      ) : null}
    </div>
  );
};

SeoPartnerSlots.propTypes = {
  partnerBlock: object,
  showHeading: bool,
  subpageSlug: string,
  venue: object,
};

export default SeoPartnerSlots;
